import axios from 'axios'
import config from '../config/config'
import user from './user'
import search from './search'
import file from './file'
axios.defaults.baseURL = config.serverURL
axios.interceptors.request.use(
  function (config) {
    var userjson = window.sessionStorage.getItem('user');
    if (userjson != "undefined") {
      let userInfo = JSON.parse(userjson)
      if (userInfo) {
        var token = userInfo.tokens[0].token;
        axios.defaults.headers.common['Authorization'] = token;
        config.headers.common['Authorization'] = token;
      }
    }
    return config
  },
  function (error) {
    alert('网络异常请检查网络')
    return Promise.reject(error)
  }
)
// 添加响应拦截器
axios.interceptors.response.use((res) => {
  //console.log(res)
  if (res && res.status) {
    let status = res.status

    if (status == 200 && res.data.code == -1) {
      window.location.href = '/'
    }
    if (status == 200) return res.data
    if (status == 404) {
      window.location.href = '/'
    }
  }
  return Promise.reject(res)
},
  (error) => {
    return Promise.reject({
      message: '本地网络错误，或服务器无响应',
    })
  }
)
export default {
  axios: axios,
  baseURL: axios.defaults.baseURL,
  post: axios.post,
  put: axios.put,
  get: axios.put,
  del: axios.delete,
  //登录
  user,
  //搜索
  search,
  //文件
  file
}
